module.exports = __webpack_public_path__ + "img/Promena-logo.28f078c9.png";